import { EventAnnotationInputModel } from 'inputModels';
import { IEventAnnotationViewModel } from 'viewModels';
import api from '../services/api/axios';

const getAnnotations = (uid: string) =>
  new Promise<IEventAnnotationViewModel[]>((resolve) => {
    api
      .get(`event/annotation/${uid}`)
      .then(({ data }) => resolve(data))
      .catch();
  });

const insertAnnotation = (input: EventAnnotationInputModel) => {
  return new Promise((resolve, reject) => {
    api
      .post(`/event/annotation`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const EventController = { getAnnotations, insertAnnotation };

export default EventController;
